import styled from 'styled-components';

export const GuestListTableContainer= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    border-radius: 10px;
    background: #FFF;
    width:100%;
    padding:29px 28px;
`;


export const ResidentCountInputContainer= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    border-radius: 32px;
    border: 1px solid var(--Indigo-bright, #CFCDFF);
    width:100%;
    padding:3px 16px 0px 16px;
    display:flex;
    input{
      paddidng:16px;
      ::placeholder{
        color: #3F3F46 !important;
      }
    }
    
`;


export const PricingContainer= styled.div
.attrs(() => ({
  className: ' mt-25 transparent',
}))`
    border-radius: 24px;
    border: 1px solid #CFCDFF;
    width: 100%;
    padding:29px 28px;
    h1{
      color: var(--Black-1, #18181B);
      font-size: 40px !important;
      font-style: normal;
      font-weight: 600;
      span{
        color: var(--Black, #3F3F46);
        font-family: Plus Jakarta Sans;
        font-size: 16px !important;
        font-style: normal;
        font-weight: 400;
      }
    }
    
`;


export const  PricingContainerBtn  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;


color: var(--white, #FFF);
background:#4F46E5;

width:100% !important;
// width:178px !important;
height:46px !important;
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;
border: 1px solid var(--primary-indigo, #4F46E5);
:hover{
  background: #000000 !important;
}
:

`;



export const FieldBtn  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;
background: #fff !important;
// width:80% !important;
// width:178px !important;
height:46px !important;
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;
color: #4F46E5;
border: 1px solid var(--primary-indigo, #4F46E5);

:hover{
color: var(--white, #FFF);
background: var(--primary-indigo, #4F46E5) !important;
}

`;